import type { AppState } from '../../store/app-state';

type AuthAndCloudState = Pick<AppState, 'auth' | 'cloud'>;
type SignOutSessionStorage = Pick<Storage, 'removeItem'>;

export const SIGNED_OUT_AUTH_CLEAR_DELAY_MS = 1000;

export function hasSignedOutSessionStateToPreserve(state: AuthAndCloudState): boolean {
    return Boolean(
        state.auth.user
        || state.auth.isAuthenticated
        || state.cloud.enabled
        || state.cloud.orgId
        || state.cloud.projectId
        || state.cloud.currentProjectId
        || state.cloud.role
        || state.cloud.member
        || state.cloud.lastSync
        || state.cloud.hasLoadedCloudProject
    );
}

export function shouldIgnoreSignedOutSessionForSeededLocalAuth(
    state: AuthAndCloudState,
    preserveSeededLocalAuth: boolean,
): boolean {
    return Boolean(preserveSeededLocalAuth && state.auth.user && state.auth.isAuthenticated);
}

export function handleSignedOutSessionState({
    preserveSeededLocalAuth,
    state,
    storage,
}: {
    preserveSeededLocalAuth: boolean;
    state: AuthAndCloudState;
    storage: SignOutSessionStorage;
}): boolean {
    if (shouldIgnoreSignedOutSessionForSeededLocalAuth(state, preserveSeededLocalAuth)) {
        return false;
    }

    storage.removeItem('SKIP_ADMIN_REDIRECT');
    return true;
}
